import isUndefined from '../type-check/is-undefined.js';
import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func addQueryParams
 * @param {string} path - The URL path
 * @param {object} params - The query params object
 * @return {string}
 * @desc Adds query params to path, returning a URL
 * ```js
 * addQueryParams('/user', { id: 1 });
 * // returns '/user?id=1'
 * ```
 * @memberof module:Navigation
 * @instance
 */
function addQueryParams(path, params = {}) {
    if (!checkTypeValidity(['object'], params))
        return path;
    const queryString = Object.entries(params)
        .filter(([, value]) => !isUndefined(value))
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return queryString ? `${path}?${queryString}` : path;
}

export { addQueryParams as default };
